// @owners { team: patients }
import { Experimentation } from '@alto/experimentation';
import { Platform } from 'react-native';
import { ALTO_COMPANY_ID, FUZE_HEALTH_COMPANY_ID } from '~shared/constants';

export const getCompanyID = (): number => {
  if (Experimentation.getFeatureValue('fuze_brand_override', false)) {
    return ALTO_COMPANY_ID;
  }

  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    return ALTO_COMPANY_ID;
  }

  const host = window.location.hostname.toLowerCase();

  if (host.includes('fuzehealth')) {
    return FUZE_HEALTH_COMPANY_ID;
  }

  return ALTO_COMPANY_ID;
};
